import { animated } from '@react-spring/web';
import React, { useMemo } from 'react';
import { Dimensions } from './hooks/useWindowDimensions';
import { replaceLinks } from './replaceLinks';
import CloseSvg from './svg/CloseSvg';
import { Theme } from './Themes';

type WinModalProps = {
	title: string;
	winTexts: string[];
	animatedStyle: any;
	onCloseClick: () => void;
	theme: Theme;
	windowDim: Dimensions;
};

const WinModal = ({ title, winTexts, animatedStyle, onCloseClick, theme, windowDim }: WinModalProps) => {
	const modalWidth = useMemo(() => Math.min(700, windowDim.width), [windowDim]);
	return winTexts.length > 1 ? (
		<animated.div
			className="relative select-none drop-shadow"
			style={{
				...animatedStyle,
				backgroundColor: theme.primary.color,
				width: modalWidth,
				borderRadius: modalWidth / 30,
				padding: modalWidth / 30,
				margin: '3%',
				zIndex: 3000,
			}}>
			<h1 className="line select-none text-center font-karusel text-lg sm:text-xl md:text-2xl xl:text-3xl" style={{ color: theme.primary.text }}>
				{winTexts[0]}
			</h1>
			{winTexts.map(
				(text, i) =>
					i > 0 && (
						<p
							key={'p' + i}
							className="text-md select-none px-16 pt-2 text-center font-karusel leading-tight sm:text-lg md:text-xl xl:px-12 xl:text-2xl"
							style={{ color: theme.primary.text }}>
							{replaceLinks(winTexts[i].replaceAll('%title', title), theme.primary.link)}
						</p>
					)
			)}
			<div className="absolute" style={{ top: modalWidth / 60, right: modalWidth / 60, cursor: 'pointer' }} onClick={onCloseClick}>
				<CloseSvg width={modalWidth / 20} height={modalWidth / 20} fill={theme.primary.link} />
			</div>
		</animated.div>
	) : (
		<div />
	);
};

export default WinModal;
